import { useMemo, useState } from "react";
import { formatLocalDateTime } from "../../../../utils/formatDate";
import Pagination from "../../../../componentes/pagination/Pagination";

function TabelaSolicitacoes({ solicitacoes }) {
    const [pageData, setPageData] = useState([]);

    const [setor, setSetor] = useState("");
    const [descricao, setDescricao] = useState("");
    const [numeroProcesso, setNumeroProcesso] = useState("");
    const [status, setStatus] = useState("");
    const [filial, setFilial] = useState("");
    const [solicitanteNome, setSolicitanteNome] = useState("");

    const solicitacoesFiltradas = useMemo(() => {
        return solicitacoes.filter((item) => {

            return (
                (setor ? item.setor === setor : true) &&
                (status ? item.status === status : true) &&
                (filial ? item.filial === filial : true) &&
                (numeroProcesso ? item.numeroProcesso.toString().includes(numeroProcesso.toLowerCase()) : true) &&
                (solicitanteNome
                    ? item.solicitanteEmail
                        .toLowerCase()
                        .includes(solicitanteNome.toLowerCase())
                    : true)
                &&
                (descricao
                    ? item.descricaoDespesa
                        .toLowerCase()
                        .includes(descricao.toLowerCase())
                    : true)
            );
        });
    }, [setor, status, filial, solicitanteNome, numeroProcesso, descricao, solicitacoes]);

    return (
        <div>
            <div className="grid grid-cols-1 md:grid-cols-6 gap-4 mb-3">
                <select
                    value={setor}
                    onChange={(e) => setSetor(e.target.value)}
                    className="px-3 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary transition-colors duration-150"
                >
                    <option value="">Todos os Setores</option>
                    {[...new Set(solicitacoes.map((s) => s.setor))].map((f) => (
                        <option key={f} value={f}>
                            {f}
                        </option>
                    ))}
                </select>

                <select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    className="px-3 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary transition-colors duration-150"
                >
                    <option value="">Todos os status</option>
                    {[...new Set(solicitacoes.map((s) => s.status))].map((s) => (
                        <option key={s} value={s}>
                            {s}
                        </option>
                    ))}
                </select>

                <select
                    value={filial}
                    onChange={(e) => setFilial(e.target.value)}
                    className="px-3 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary transition-colors duration-150"
                >
                    <option value="">Todas as filiais</option>
                    {[...new Set(solicitacoes.map((s) => s.filial))].map((f) => (
                        <option key={f} value={f}>
                            {f}
                        </option>
                    ))}
                </select>

                <input
                    type="text"
                    value={numeroProcesso}
                    onChange={(e) => setNumeroProcesso(e.target.value)}
                    placeholder="Filtrar por Processo"
                    className="px-3 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary transition-colors duration-150"
                />

                <input
                    type="text"
                    value={solicitanteNome}
                    onChange={(e) => setSolicitanteNome(e.target.value)}
                    placeholder="Filtrar por solicitante"
                    className="px-3 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary transition-colors duration-150"
                />

                <input
                    type="text"
                    value={descricao}
                    onChange={(e) => setDescricao(e.target.value)}
                    placeholder="Filtrar por descricao"
                    className="px-3 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary transition-colors duration-150"
                />

            </div>
            <div className="overflow-y-auto max-h-[400px] border border-border rounded-lg">
                <table className="min-w-full border-collapse divide-y divide-border">
                    <thead className="bg-table-header text-table-header-fg sticky top-0">
                        <tr>
                            <th className="px-6 py-2 text-center text-xs font-medium uppercase sticky top-0 left-0 bg-table-header z-30">Processo</th>
                            <th className="px-6 py-2 text-center text-xs font-medium uppercase sticky top-0 left-0 bg-table-header z-30">Início</th>
                            <th className="px-6 py-2 text-center text-xs font-medium uppercase sticky top-0 left-0 bg-table-header z-30">Encerramento</th>
                            <th className="px-6 py-2 text-center text-xs font-medium uppercase sticky top-0 left-0 bg-table-header z-30">Status</th>
                            <th className="px-6 py-2 text-center text-xs font-medium uppercase sticky top-0 left-0 bg-table-header z-30">Filial</th>
                            <th className="px-6 py-2 text-center text-xs font-medium uppercase sticky top-0 left-0 bg-table-header z-30">Solicitante</th>
                            <th className="px-6 py-2 text-center text-xs font-medium uppercase sticky top-0 left-0 bg-table-header z-30">setor</th>
                            <th className="px-6 py-2 text-center text-xs font-medium uppercase sticky top-0 left-0 bg-table-header z-30">Descrição da Despesa</th>
                            <th className="px-6 py-2 text-center text-xs font-medium uppercase sticky top-0 left-0 bg-table-header z-30">Valor Total</th>
                            <th className="px-6 py-2 text-center text-xs font-medium uppercase sticky top-0 left-0 bg-table-header z-30">Tipo do Pagamento</th>
                            <th className="px-6 py-2 text-center text-xs font-medium uppercase sticky top-0 left-0 bg-table-header z-30">Vencimento</th>
                        </tr>
                    </thead>
                    <tbody className="bg-card divide-y divide-border">
                        {pageData.map((item, index) => (
                            <tr key={index} className="text-sm hover:bg-table-row-hover transition-colors">
                                <td className="px-6 py-2 whitespace-nowrap font-medium text-foreground">
                                    <a href={`http://fluig.yorkdistribuidora.com.br:35792/portal/p/1/pageworkflowview?app_ecm_workflowview_detailsProcessInstanceID=${item.numeroProcesso}`} target="_blank">
                                        {item.numeroProcesso}
                                    </a>
                                </td>
                                <td className="px-6 py-2 whitespace-nowrap text-foreground">{formatLocalDateTime(item.dataInicio?.toLocaleString())}</td>
                                <td className="px-6 py-2 whitespace-nowrap text-foreground">{formatLocalDateTime(item.dataEncerramento?.toLocaleString())}</td>
                                <td className="px-6 py-2 whitespace-nowrap text-muted-foreground">{item.status}</td>
                                <td className="px-6 py-2 whitespace-nowrap text-muted-foreground">{item.filial}</td>
                                <td className="px-6 py-2 whitespace-nowrap text-muted-foreground">{item.solicitanteEmail.split("@")[0] || ''}</td>
                                <td className="px-6 py-2 whitespace-nowrap text-muted-foreground">{item.setor}</td>
                                <td className="px-6 py-2 whitespace-nowrap text-muted-foreground">{item.descricaoDespesa}</td>
                                <td className="px-6 py-2 whitespace-nowrap text-muted-foreground">R$ {item.valorDespesa?.toFixed(2)}</td>
                                <td className="px-6 py-2 whitespace-nowrap text-muted-foreground">{item.tipoPagamento}</td>
                                <td className="px-6 py-2 whitespace-nowrap text-muted-foreground">{item.vencimento}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <Pagination
                pageSizeOptions={[50, 100, 200, 100]}
                data={solicitacoesFiltradas}
                length={pageData.length}
                currentData={setPageData}
            />
        </div>
    );
}

export default TabelaSolicitacoes;
